export const WAITING_DAYS_STACKED_BAR_COLORS = ['var(--color-brand-light)', 'var(--color-brand-primary)', 'var(--color-status-warning)'] as const;
